// Medical Constants
export const GET_PRESCRIPTIONS_REQUEST = "GET_PRESCRIPTIONS_REQUEST";
export const GET_PRESCRIPTIONS_SUCCESS = "GET_PRESCRIPTIONS_SUCCESS";
export const GET_PRESCRIPTIONS_FAILURE = "GET_PRESCRIPTIONS_FAILURE";

export const UPDATE_DELIVERY_STATUS_REQUEST = "UPDATE_DELIVERY_STATUS_REQUEST";
export const UPDATE_DELIVERY_STATUS_SUCCESS = "UPDATE_DELIVERY_STATUS_SUCCESS";
export const UPDATE_DELIVERY_STATUS_FAILURE = "UPDATE_DELIVERY_STATUS_FAILURE";

export const ADD_DELIVERY_ADDRESS_REQUEST = "ADD_DELIVERY_ADDRESS_REQUEST";
export const ADD_DELIVERY_ADDRESS_SUCCESS = "ADD_DELIVERY_ADDRESS_SUCCESS";
export const ADD_DELIVERY_ADDRESS_FAILURE = "ADD_DELIVERY_ADDRESS_FAILURE";

export const SET_SELECTED_PRESCRIPTION = "SET_SELECTED_PRESCRIPTION";
export const CLEAR_MEDICAL_ERRORS = "CLEAR_MEDICAL_ERRORS";
export const RESET_SELECTED_MEDICINES = "RESET_SELECTED_MEDICINES";


// download 
export const PRESCRIPTION_DOWNLOAD_REQUEST = "PRESCRIPTION_DOWNLOAD_REQUEST";
export const PRESCRIPTION_DOWNLOAD_SUCCESS = "PRESCRIPTION_DOWNLOAD_SUCCESS";
export const PRESCRIPTION_DOWNLOAD_FAILURE = "PRESCRIPTION_DOWNLOAD_FAILURE";

export const PRESCRIPTION_FIRST_ASSIGNED_REQUEST =
    "PRESCRIPTION_FIRST_ASSIGNED_REQUEST";
export const PRESCRIPTION_FIRST_ASSIGNED_SUCCESS =
    "PRESCRIPTION_FIRST_ASSIGNED_SUCCESS";
export const PRESCRIPTION_FIRST_ASSIGNED_FAILURE =
    "PRESCRIPTION_FIRST_ASSIGNED_FAILURE";